export default "__VITE_ASSET__4g9Bkx7g__"